/** 自定义待支付账单确认弹窗 */

/** 取消支付策略 */
export var ECancelPayStrategy;
(function (ECancelPayStrategy) {
  ECancelPayStrategy["billAndPay"] = "billAndPay";
  ECancelPayStrategy["onlyPay"] = "onlyPay";
})(ECancelPayStrategy || (ECancelPayStrategy = {}));